// extracted by mini-css-extract-plugin
export default {"Task":"Task-module-a74106689b7e21957818","taskIcon":"Task-module-f08f6b3017d90ab155fb","location":"Task-module-ac6608f1b1f91a977f4b"};